/* ═══ KLEINE BLOESEM — blaadjes, easter eggs & winkelwagen (uit het artifact-concept) ═══ */
(function () {
  var KLEUREN = ['#E8A2B0', '#C97B8E', '#EFD7B0'];

  function blaadjeSVG(kleur, maat) {
    var w = document.createElement('span');
    w.innerHTML = '<svg aria-hidden="true" focusable="false" class="kb-blaadje" width="' + maat + '" height="' + maat + '" viewBox="0 0 20 20" style="animation-delay:' + (Math.random() * 4).toFixed(1) + 's;animation-duration:' + (6 + Math.random() * 4).toFixed(1) + 's"><ellipse cx="10" cy="10" rx="7" ry="4.5" fill="' + kleur + '" opacity="' + (0.35 + Math.random() * 0.3).toFixed(2) + '" transform="rotate(' + Math.floor(Math.random() * 90 - 45) + ' 10 10)"/></svg>';
    return w.firstElementChild;
  }

  function strooi() {
    document.querySelectorAll('.kb-hero, .kb-usp-band, .kb-cadeau-band, .kb-nieuwsbrief, .kb-winkel').forEach(function (el) {
      el.style.position = 'relative';
      for (var i = 0; i < 3; i++) {
        var b = blaadjeSVG(KLEUREN[Math.floor(Math.random() * KLEUREN.length)], 14 + Math.floor(Math.random() * 14));
        b.style.left = (4 + Math.random() * 90) + '%';
        b.style.top = (5 + Math.random() * 80) + '%';
        el.appendChild(b);
      }
    });
  }

  function toast(tekst) {
    var t = document.querySelector('.kb-toast');
    if (!t) { t = document.createElement('div'); t.className = 'kb-toast'; document.body.appendChild(t); }
    t.textContent = tekst;
    requestAnimationFrame(function () { t.classList.add('zichtbaar'); });
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('zichtbaar'); }, 3500);
  }

  function bloesemregen() {
    var kleuren = ['#E8A2B0', '#C97B8E', '#F6E3E7', '#EFD7B0'];
    for (var i = 0; i < 60; i++) {
      var maat = 12 + Math.floor(Math.random() * 16);
      var w = document.createElement('span');
      w.innerHTML = '<svg aria-hidden="true" focusable="false" class="kb-regen-blaadje" width="' + maat + '" height="' + maat + '" viewBox="0 0 20 20"><ellipse cx="10" cy="10" rx="7" ry="4.5" fill="' + kleuren[i % 4] + '" opacity=".85"/></svg>';
      var b = w.firstElementChild;
      b.style.left = Math.random() * 100 + 'vw';
      b.style.setProperty('--zwaai', (Math.random() * 160 - 80) + 'px');
      b.style.animationDuration = (2.5 + Math.random() * 3) + 's';
      b.style.animationDelay = (Math.random() * 1.2) + 's';
      document.body.appendChild(b);
      (function (el) { setTimeout(function () { el.remove(); }, 7000); })(b);
    }
  }

  /* easter egg: 3x klikken op het logo */
  var kliks = 0, timer;
  document.addEventListener('click', function (e) {
    var logo = e.target.closest('a.header-logo, a[class*="header-logo"]');
    if (!logo) return;
    var opHome = location.pathname === '/' || location.pathname === '';
    if (!opHome) return; /* elders: logo navigeert gewoon naar home */
    e.preventDefault();  /* op home doet de logoklik toch niets — tel voor het geheimpje */
    kliks++;
    clearTimeout(timer);
    timer = setTimeout(function () { kliks = 0; }, 1500);
    if (kliks === 3) {
      kliks = 0;
      bloesemregen();
      toast('🌸 Bloesemregen! Je hebt ons beertje blij gemaakt.');
    }
  }, true);

  /* onthulling bij scroll */
  function onthul() {
    if (!('IntersectionObserver' in window)) return;
    var w = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('zichtbaar'); w.unobserve(e.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('.kb-onthul:not(.zichtbaar)').forEach(function (el) { w.observe(el); });
  }

  /* in winkelwagen (custom kaarten) */
  var tas = 0, eggGetoond = false;
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('.kb-in-wagen[data-variant]');
    if (!knop) return;
    e.preventDefault();
    var origineel = knop.textContent;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(knop.dataset.variant), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error();
      knop.textContent = 'Toegevoegd ✓';
      tas++;
      if (tas === 10 && !eggGetoond) { eggGetoond = true; bloesemregen(); toast('🧸 Tien speeltjes! Iemand maakt kleine mensjes héél blij.'); }
      /* thema-tasje bijwerken: Horizon luistert op 'cart:update' met detail.data.itemCount */
      fetch('/cart.js').then(function (c) { return c.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, data: { itemCount: cart.item_count, source: 'kb-kaart' } } }));
      });
      toast('🌸 Toegevoegd aan je winkelwagen');
      setTimeout(function () { knop.textContent = origineel; }, 1600);
    }).catch(function () {
      knop.textContent = 'Even niet gelukt';
      setTimeout(function () { knop.textContent = origineel; }, 1600);
    });
  });

  /* "Bekijk winkelwagen"-knop in de zijbalk -> volledige /cart-pagina */
  function winkelwagenLink() {
    document.querySelectorAll('.cart__checkout-button, [name="checkout"]').forEach(function (knop) {
      if (!knop.closest('cart-drawer-component, .cart-drawer')) return;
      var houder = knop.parentElement;
      if (!houder || houder.querySelector('.kb-bekijk-wagen')) return;
      var link = document.createElement('a');
      link.href = '/cart';
      link.className = 'kb-bekijk-wagen';
      link.textContent = 'Bekijk winkelwagen';
      houder.insertBefore(link, knop);
    });
  }
  function bindWinkelwagenLink() {
    winkelwagenLink();
    document.addEventListener('cart:update', winkelwagenLink);
    var doel = document.querySelector('cart-drawer-component, .cart-drawer') || document.body;
    try { new MutationObserver(winkelwagenLink).observe(doel, { childList: true, subtree: true }); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { strooi(); onthul(); bindWinkelwagenLink(); });
  } else { strooi(); onthul(); bindWinkelwagenLink(); }
})();

/* === Fotocarrousel: puntjes, pijltjes en swipe-vs-klik (17-8-2026) === */
(function(){
  function init(strip){
    if (strip.dataset.kbStrip) return;
    strip.dataset.kbStrip = '1';
    var beeld = strip.closest('.kb-product-beeld');
    if (!beeld) return;
    var punten = beeld.querySelectorAll('.kb-fotostrip-punten span');
    var items = strip.querySelectorAll('.kb-fotostrip-item');

    function huidig(){
      return Math.round(strip.scrollLeft / strip.clientWidth);
    }
    function werkPuntenBij(){
      var i = Math.max(0, Math.min(punten.length - 1, huidig()));
      punten.forEach(function(p, n){ p.classList.toggle('actief', n === i); });
    }
    var wacht;
    strip.addEventListener('scroll', function(){
      clearTimeout(wacht);
      wacht = setTimeout(werkPuntenBij, 60);
    }, {passive:true});

    /* Eigen tween: scrollTo({behavior:'smooth'}) blijkt in sommige browsers
       en automatiseringscontexten niet te animeren en dan gebeurt er niets. */
    function schuifNaar(doel){
      var start = strip.scrollLeft, afstand = doel - start, begin = null;
      if (Math.abs(afstand) < 2) { strip.scrollLeft = doel; werkPuntenBij(); return; }
      var klaar = false;
      function afronden(){
        if (klaar) return;
        klaar = true;
        strip.scrollLeft = doel;
        werkPuntenBij();
      }
      function stap(tijd){
        if (klaar) return;
        if (begin === null) begin = tijd;
        var v = Math.min(1, (tijd - begin) / 260);
        var e = 1 - Math.pow(1 - v, 3);
        strip.scrollLeft = start + afstand * e;
        if (v < 1) requestAnimationFrame(stap); else afronden();
      }
      requestAnimationFrame(stap);
      /* Terugval: in een achtergrondtab of bij frame-throttling vuurt rAF niet.
         Dan springt hij alsnog naar de juiste foto in plaats van vast te blijven. */
      setTimeout(afronden, 320);
    }
    function ga(richting){
      var i = huidig() + richting;
      if (i < 0) i = items.length - 1;
      if (i > items.length - 1) i = 0;
      schuifNaar(i * strip.clientWidth);
    }
    var vorige = beeld.querySelector('.kb-fotostrip-vorige');
    var volgende = beeld.querySelector('.kb-fotostrip-volgende');
    if (vorige) vorige.addEventListener('click', function(e){ e.preventDefault(); ga(-1); });
    if (volgende) volgende.addEventListener('click', function(e){ e.preventDefault(); ga(1); });

    /* Een horizontale sleep mag geen productpagina openen */
    var startX = null;
    strip.addEventListener('pointerdown', function(e){ startX = e.clientX; }, {passive:true});
    strip.addEventListener('click', function(e){
      if (startX !== null && Math.abs(e.clientX - startX) > 10) {
        e.preventDefault();
        e.stopPropagation();
      }
      startX = null;
    });
  }

  function scan(){ document.querySelectorAll('.kb-fotostrip').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, {childList:true, subtree:true});
})();
